import Popup from './Popup';
import {Button,ButtonGroup,Box} from '@mui/material';
import MethodButtonRows,{getVisibleMethodGroups} from './MethodButtonRows';

const DetailFormPopup=({
    application,
    componentBody,
    handleClickEvent,
    isChanged,
    title,
    readOnly,
    recordRules,
    fromPopup,
    openOnUpdate,
    handleClickMethodButton})=>{

    const zIndex=1300+(fromPopup?1:0);
    const footerComponent=(
        <Box sx={{display:'flex',justifyContent:'flex-end',mt:3}}>
            <Button onClick={()=>{handleClickEvent({action:'close_popup'})}}>{application.getLocale('ButtonClose')}</Button>
        </Box>
    );
    // Same method-groups rendering as DetailForm.js (non-popup) - popups previously only ever
    // showed the generic Update/Save/Cancel actions, so a model's own methods()/invoke_method()
    // buttons (e.g. Manufacturing Order's "Mark as Produced") never appeared when edited in a popup.
    const headerComponent=(
        <MethodButtonRows
            sx={{pb:'10px'}}
            methodGroups={getVisibleMethodGroups(recordRules,readOnly)}
            handleClickMethodButton={handleClickMethodButton}
            application={application}
            mainButtons={(
            <ButtonGroup size="small" sx={{'& .MuiButton-root':{whiteSpace:'nowrap'}}}>
                {readOnly&&recordRules?.can_update_record===true&&<Button name="update" variant="outlined" onClick={()=>{handleClickEvent({action:'update'})}}>{application.getLocale('ButtonUpdate')}</Button>}
                {!readOnly&&<Button disabled={!isChanged} name="save_popup" variant={isChanged?"contained":"outlined"} onClick={()=>{handleClickEvent({action:'save_popup'})}}>{application.getLocale('ButtonSave')}</Button>}
                {!readOnly&&<Button name="cancel" variant="outlined" onClick={()=>{handleClickEvent({action:openOnUpdate?'close_popup':'cancel'})}}>{application.getLocale('ButtonCancel')}</Button>}
            </ButtonGroup>
            )}/>
    );

    return (
        <Popup
            title={title}
            zIndex={zIndex}
            onClose={()=>handleClickEvent({action:'close_popup'})}
            headerComponent={headerComponent}
            footerComponent={footerComponent}>
        {componentBody}
        </Popup>
    );
};

export default DetailFormPopup;